// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAPlYJmQ97EFkW3BgLM1tVnodfwSsi9SsY",
  authDomain: "bb8-csa.firebaseapp.com",
  projectId: "bb8-csa",
  storageBucket: "bb8-csa.firebasestorage.app",
  messagingSenderId: "637218624276",
  appId: "1:637218624276:web:8bd3c6722488f578e4e801",
  measurementId: "G-0DM9PWDGVW"
};
// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);
// 🚀 Get token
export const requestForToken = async () => {
  try {
    const currentToken = await getToken(messaging, {
      vapidKey: "BFb_69PPl0n4c2ZbNi-B-kNMfiex6jNP_39_cMBpQbTsBSymDllckxYLEjLCoZOP2zkJkhUjczaVo1e_sh8bQ-A", // Replace with actual VAPID key
    });
    return currentToken;
  } catch (err) {
    console.error("FCM Token Error:", err);
    return null;
  }
};

// 🎯 Foreground listener
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
